import React from 'react';

export const socialLinks = [
  { name: 'youtube', url: 'https://www.youtube.com/@AdamGMakes' },
  { name: 'instagram', url: 'https://www.instagram.com/adamgmakes/' },
  { name: 'tiktok', url: 'https://www.tiktok.com/@adamgmakes' },
  { name: 'linkedin', url: 'https://www.linkedin.com/in/adam-gordon1/' },
  { name: 'github', url: 'https://github.com/Gordoa40' },
  { name: 'patreon', url: 'https://www.patreon.com/cw/AdamGMakes' },
];

export const SocialIcons = ({ className = '' }) => (
  <div className={`flex items-center gap-5 ${className}`}>
    {socialLinks.map((social) => (
      <a
        key={social.name}
        href={social.url}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={social.name}
        className="text-muted-light dark:text-muted-dark hover:text-copper-600 dark:hover:text-copper-400 transition-colors"
      >
        <i className={`fab fa-${social.name} text-xl`}></i>
      </a>
    ))}
  </div>
);

const Footer = () => {
  return (
    <footer className="border-t border-line-light dark:border-line-dark">
      <div className="max-w-site mx-auto px-5 py-8 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-sm text-muted-light dark:text-muted-dark">
          &copy; {new Date().getFullYear()} Adam Gordon
        </p>
        <SocialIcons />
      </div>
    </footer>
  );
};

export default Footer;
